const CONSTANTS = {
  DEFAULT_USER_NAME_VALUE_IA_REPORT_FILTER: 'All',
  DEFAULT_AGENT_NAME_VALUE_IA_REPORT_FILTER: 'All',
}

export default CONSTANTS;